import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { SiteProvider, useSite } from './context/SiteContext';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Departments from './pages/Departments';
import DepartmentDetail from './pages/DepartmentDetail';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import News from './pages/News';
import NewsDetail from './pages/NewsDetail';
import Notices from './pages/Notices';
import NoticeDetail from './pages/NoticeDetail';
import Tenders from './pages/Tenders';
import TenderDetail from './pages/TenderDetail';
import Downloads from './pages/Downloads';
import Gallery from './pages/Gallery';
import GalleryDetail from './pages/GalleryDetail';
import RTI from './pages/RTI';
import Grievance from './pages/Grievance';
import Contact from './pages/Contact';
import Search from './pages/Search';
import PageView from './pages/PageView';
import Officers from './pages/Officers';
import Employees from './pages/Employees';
import WardCouncillors from './pages/WardCouncillors';
import Projects from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';
import ScrollToTop from './components/ScrollToTop';
import './App.css';
import TradeLicense from './pages/TradeLicense/TradeLicense';
import CertificateView from './pages/TradeLicense/CertificateView';
import OfficeLayout from './pages/Office/OfficeLayout';
import OfficialLogin from './pages/OfficialLogin';

// Component to update document title from site config
function TitleUpdater() {
  const { config } = useSite();

  React.useEffect(() => {
    if (config?.site_name) {
      document.title = config.site_name;
    }
  }, [config]);

  return null; // This component doesn't render anything
}

// Component to conditionally render trade license routes
function TradeLicenseRoutes() {
  const { moduleAccess } = useSite();

  if (!moduleAccess.trade_license) {
    return null;
  }

  return (
    <>
      <Route path="/trade-license/certificate/:license_number" element={<CertificateView />} />
      <Route path="/trade-license/*" element={<TradeLicense />} />
    </>
  );
}

function TradeLicenseOfficeRoutes() {
  const { moduleAccess } = useSite();

  if (!moduleAccess.trade_license) {
    return null;
  }

  return (
    <>
      <Route path="/office/*" element={<OfficeLayout />} />
    </>
  );
}

function App() {
  return (
    <SiteProvider>
      <TitleUpdater />
      <Router>
        <ScrollToTop />
        <AppRoutes />
      </Router>
    </SiteProvider>
  );
}

function AppRoutes() {
  const { moduleAccess } = useSite();
  return (
    <Routes>
          <Route path="/official-login" element={<OfficialLogin />} />
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="departments" element={<Departments />} />
            <Route path="departments/:slug" element={<DepartmentDetail />} />
            <Route path="services" element={<Services />} />
            <Route path="services/:slug" element={<ServiceDetail />} />
            <Route path="news" element={<News />} />
            <Route path="news/:slug" element={<NewsDetail />} />
            <Route path="notices" element={<Notices />} />
            <Route path="notices/:slug" element={<NoticeDetail />} />
            <Route path="tenders" element={<Tenders />} />
            <Route path="tenders/:slug" element={<TenderDetail />} />
            <Route path="downloads" element={<Downloads />} />
            <Route path="downloads/:category" element={<Downloads />} />
            <Route path="gallery" element={<Gallery />} />
            <Route path="gallery/:slug" element={<GalleryDetail />} />
            <Route path="rti" element={<RTI />} />
            <Route path="grievance" element={<Grievance />} />
            <Route path="contact" element={<Contact />} />
            <Route path="search" element={<Search />} />
            <Route path="pages/:slug" element={<PageView />} />
            <Route path="officers" element={<Officers />} />
            <Route path="employees" element={<Employees />} />
            <Route path="ward-councillors" element={<WardCouncillors />} />
            <Route path="projects" element={<Projects />} />
            <Route path="projects/:slug" element={<ProjectDetail />} />
            {moduleAccess.trade_license && (
            <>
              <Route path="/trade-license/certificate/:license_number" element={<CertificateView />} />            
              <Route path="/trade-license/*" element={<TradeLicense />} />    
            </>                    
            )}
          </Route>
           {moduleAccess.trade_license && (
            <Route path="/office/*" element={<OfficeLayout />} />
           )}
        </Routes>
  );
}

export default App;
